import { createAction, props } from "@ngrx/store";
export const setGenericDocJournalListing_State = createAction(
  "[Column 1 View Model] Set Generic Doc Journal Listing State",
  props<{ genericDocJournalListingState: any }>()
);